module.exports = __webpack_public_path__ + "static/media/037-dental.836c17ef.svg";